/**
 * Shared helpers for the optional follow-up task created when sending email.
 * The delay is in working days, counted by the server under the tenant's working-days
 * setting (Settings → General). The Account setting is the default; the composer can change the delay or
 * skip the task on a given send. Prospect compose turns the task on; client
 * compose leaves it off until the operator adds one.
 */

export const DEFAULT_FOLLOW_UP_TASK_DAYS = 3;
export const MIN_FOLLOW_UP_TASK_DAYS = 1;
export const MAX_FOLLOW_UP_TASK_DAYS = 90;

export interface EmailFollowUp {
  enabled: boolean;
  dueInDays: number;
}

export function clampFollowUpDays(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_FOLLOW_UP_TASK_DAYS;
  return Math.min(MAX_FOLLOW_UP_TASK_DAYS, Math.max(MIN_FOLLOW_UP_TASK_DAYS, Math.round(value)));
}

export function followUpTaskName(toName: string | undefined, subject: string): string {
  const who = toName?.trim();
  if (who) return `Follow up with ${who}`;
  const trimmed = subject.trim();
  return trimmed && trimmed !== 'No subject' ? `Follow up: ${trimmed}` : 'Follow up';
}

/**
 * Follow-up is on by default on pre-sale records (prospect, lead, …).
 * Client records leave it off until the operator adds one.
 */
export function followUpDefaultOnForLifecycle(stage: string | null | undefined): boolean {
  return stage != null && stage !== 'CLIENT';
}
